import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Button, Form, InputGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import google from "../assets/images/google.png";
import facebook from "../assets/images/facebook.png";
import { useNavigate } from "react-router-dom";

const LoginForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    remember: false,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Basic email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim()); // Trim spaces before validation
  };

  // Login form submission with validation
  const handleLogin = async (e) => {
    e.preventDefault();
    let validationErrors = {};

    // Email validation
    if (!formData.email.trim()) {
      validationErrors.email = "Email is required.";
    } else if (!validateEmail(formData.email)) {
      validationErrors.email = "Please enter a valid email address.";
    }

    // Password validation
    if (!formData.password.trim()) {
      validationErrors.password = "Password is required.";
    }

    // If there are validation errors, update state and prevent form submission
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Set login status in localStorage
    localStorage.setItem("isLoggedIn", true);

    navigate("/");
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="login-box">
      <h2>Login</h2>
      <p>Gateway to tailored medical insights and supportive community.</p>
      <div className="social-login-buttons">
        <button className="google-btn">
          <img src={google} alt="Google Logo" className="google-logo" />
          Continue with Google
        </button>

        <button className="facebook-btn">
          <img src={facebook} alt="Facebook Logo" className="facebook-logo" />
          Login with Facebook
        </button>
      </div>
      <div className="or-divider">
        <div>
          <span>or Sign in with Email</span>
        </div>
      </div>
      <Form onSubmit={handleLogin} className="form login-form">
        <Form.Group className="mb-4">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="text"
            name="email"
            placeholder="Email address"
            value={formData.email}
            onChange={handleChange}
            isInvalid={!!errors.email} // Ensure invalid state is set for email
          />
          <Form.Control.Feedback type="invalid">
            {errors.email}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="password-field mb-3">
          <Form.Label>Password</Form.Label>
          <div className={`input-group ${errors.password ? "is-invalid" : ""}`}>
            <Form.Control
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              isInvalid={!!errors.password} // Ensure invalid state is set for password
              className="form-control"
            />
            <InputGroup.Text
              onClick={togglePasswordVisibility}
              className="eye-icon"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </InputGroup.Text>
          </div>
          {errors.password && (
            <div className="invalid-feedback">{errors.password}</div>
          )}
        </Form.Group>

        <div className="form-options d-flex justify-content-between">
          <Form.Check
            type="checkbox"
            label="Remember me"
            name="remember"
            checked={formData.remember}
            onChange={handleChange}
            className="custom-checkbox"
          />
          <Link to="/forgot-password" className="forgot-password">
            Forgot your password?
          </Link>
        </div>

        <Button type="submit" className="full-btn sign-in-btn w-100">
          Login
        </Button>
      </Form>
      <p className="register-link">
        Not a registered yet? <Link to="/register">Create an account</Link>
      </p>
    </div>
  );
};

export default LoginForm;
